// Standard library imports
import React, { useState } from 'react';
// External library imports
import { Form, Formik } from 'formik';
import { toast } from 'react-toastify';
import { get as lodashGet } from 'lodash';

// Internal module imports
import Typography from '../../../../components/Typography/Typography';
import { useLoader, useUserRole } from '../../../../hooks';
import { Input } from '../../../../components/Inputs/Input';
import allDeviceClasses from '../../../../styles/AllDevices.module.css';
import { RootBiddingService } from '../../../../services/BiddingService/Root/BiddingService';
import { ResultIdsValidator } from '../../../../validations/BiddingService/Bidding';
import { AdminBiddingService } from '../../../../services/BiddingService/Admin/BiddingService';
import { RootBundleBiddingService } from '../../../../services/BiddingService/Root/BundleBiddingService';
import { AdminBundleBiddingService } from '../../../../services/BiddingService/Admin/BundleBiddingService';

const ResultId = ({ bid, closeModal, getBids, bidType }) => {
    const { isRootUser } = useUserRole();
    const service = isRootUser ? (bidType === 'bundle' ? RootBundleBiddingService : RootBiddingService) : bidType === 'bundle' ? AdminBundleBiddingService : AdminBiddingService;
    const [startLoader, stopLoader] = useLoader();

    const initialValues = {
        primaryResultMessageId: lodashGet(bid, ['primary', 'provider', 'resultMessageId'], ''),
        ...(bid.market.includes('FCR-D') ? { secondaryResultMessageId: lodashGet(bid, ['secondary', 'provider', 'resultMessageId'], '') } : {}),
        reserveBidIdentification: lodashGet(bid, ['reserveBidIdentification'], ''),
    };

    const handleSubmit = (values) => {
        const payload = { ...values };
        service.UpdateResultId(bid._id, payload, startLoader, handleSuccess, handleError, stopLoader);
    };

    const handleSuccess = ({ res }) => {
        toast.success('Updated Successfully');
        closeModal();
        getBids();
    };

    const handleError = (err) => {
        toast.error(lodashGet(err, ['response', 'data', 'message']));
    };

    return (
        <div>
            <Typography content={'Result Message ID'} size="16" />
            <div style={{ width: '20vw' }}>
                <Formik enableReinitialize initialValues={initialValues} onSubmit={handleSubmit} validationSchema={ResultIdsValidator}>
                    <Form>
                        <div className={allDeviceClasses.FieldControl2}>
                            <label>Result Message ID (Primary)</label>
                            <Input name="primaryResultMessageId" id="primaryResultMessageId" type="number" style={{ marginTop: '0' }} />
                        </div>
                        {bid.market.includes('FCR-D') && (
                            <div className={allDeviceClasses.FieldControl2}>
                                <label>Result Message ID (Secondary)</label>
                                <Input name="secondaryResultMessageId" id="secondaryResultMessageId" type="number" style={{ marginTop: '0' }} />
                            </div>
                        )}
                        <div className={allDeviceClasses.FieldControl2}>
                            <label>
                                Reserve Bid Identification <span className="required">*</span>
                            </label>
                            <Input name="reserveBidIdentification" id="reserveBidIdentification" type="text" style={{ marginTop: '0' }} />
                        </div>
                        <div className={allDeviceClasses.ButtonContainer}>
                            <div>
                                <button type="button" className="btn-secondary" onClick={() => closeModal()}>
                                    Cancel
                                </button>
                            </div>
                            <div>
                                <button type="submit" className="btn-primary">
                                    Submit
                                </button>
                            </div>
                        </div>
                    </Form>
                </Formik>
            </div>
        </div>
    );
};

export default ResultId;
